export default {
  testHostUrl: 'https://dev.retrocausal.tech/',
  prodHostUrl: 'https://backend.retrocausal.tech/',
  localHostUrl: 'http://127.0.0.1:8000/',
};
